/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Code_Claimed_DescriptionInputs */

const en_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ve already entered an invite code and claimed your 300 coins.`)
};

const ar_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد أدخلت رمز دعوة بالفعل وحصلت على 300 عملة.`)
};

const de_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast bereits einen Einladungscode eingegeben und deine 300 Münzen erhalten.`)
};

const es_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya has introducido un código de invitación y reclamado tus 300 monedas.`)
};

const fr_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà saisi un code d’invitation et réclamé vos 300 pièces.`)
};

const it_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già inserito un codice invito e riscosso le tue 300 monete.`)
};

const ja_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードはすでに入力済みで、300コインも受け取り済みです。`)
};

const ko_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 초대 코드를 입력했고 코인 300개를 받았어요.`)
};

const pt_br_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já inseriu um código de convite e resgatou suas 300 moedas.`)
};

const ru_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уже ввели код приглашения и получили свои 300 монет.`)
};

const th_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกรอกรหัสเชิญไปแล้ว และรับ 300 เหรียญแล้ว`)
};

const tr_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten bir davet kodu girdin ve 300 jetonunu aldın.`)
};

const zh_cn_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已经输入过邀请码，并已领取 300 金币。`)
};

const zh_tw_invite_code_claimed_description = /** @type {(inputs: Invite_Code_Claimed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已經輸入過邀請碼，並已領取 300 金幣。`)
};

/**
* | output |
* | --- |
* | "You’ve already entered an invite code and claimed your 300 coins." |
*
* @param {Invite_Code_Claimed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_code_claimed_description = /** @type {((inputs?: Invite_Code_Claimed_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Code_Claimed_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_code_claimed_description(inputs)
	if (locale === "ar") return ar_invite_code_claimed_description(inputs)
	if (locale === "de") return de_invite_code_claimed_description(inputs)
	if (locale === "es") return es_invite_code_claimed_description(inputs)
	if (locale === "fr") return fr_invite_code_claimed_description(inputs)
	if (locale === "it") return it_invite_code_claimed_description(inputs)
	if (locale === "ja") return ja_invite_code_claimed_description(inputs)
	if (locale === "ko") return ko_invite_code_claimed_description(inputs)
	if (locale === "pt_br") return pt_br_invite_code_claimed_description(inputs)
	if (locale === "ru") return ru_invite_code_claimed_description(inputs)
	if (locale === "th") return th_invite_code_claimed_description(inputs)
	if (locale === "tr") return tr_invite_code_claimed_description(inputs)
	if (locale === "zh_cn") return zh_cn_invite_code_claimed_description(inputs)
	return zh_tw_invite_code_claimed_description(inputs)
});